import { Button } from "react-bootstrap";

const VehicleCategoriesHeader = ({ searchTerm, onSearchChange, total, onAddCategory }) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0">Vehicle Categories</h4>
      <div className="d-flex gap-2 align-items-center">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search categories"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <span className="badge bg-primary">Total: {total}</span>
        <Button type="button" onClick={onAddCategory}>
          + Add Category
        </Button>
      </div>
    </div>
  );
};

export default VehicleCategoriesHeader;
